import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import modalStyle from '../../../_common/core/modalStyle'
import Button from '../../_library/Button'
import Select from 'react-select'
import _reduce from 'lodash/reduce'
import _get from 'lodash/get'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { bulkPosTicketTypeDownload } from '../../../_common/core/http_services/tickets'
import { showAxiosError } from '../../utils/messenger'
import _map from 'lodash/map'
import JSZip from 'jszip'
import axios from 'axios'
import update from 'react-addons-update'

const TicketTypeBulkPrint = ({ ticketTypes, event }) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedTicketTypeId, setSelectedTicketTypeId] = useState(null)
  const [selectOptions, setSelectOptions] = useState([])
  const [fetchingTickets, setFetchingTickets] = useState(false)
  const [isValidSelection, setIsValidSelection] = useState(false)
  const [ticketFiles, setTicketFiles] = useState([])
  const [totalFiles, setTotalFiles] = useState(0)
  const fetchCancelToken = useRef(null)
  const canDownloadAllFiles =
    !fetchingTickets && !!selectedTicketTypeId && ticketFiles.length > 0 && ticketFiles.length === totalFiles

  useEffect(() => {
    setSelectOptions(
      _reduce(
        ticketTypes,
        (selectOptions, ticketType, i) => {
          selectOptions.push({ value: ticketType.id, label: ticketType.displayName })
          return selectOptions
        },
        [],
      ),
    )
  }, [ticketTypes])

  const openModal = () => {
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false)
    setSelectedTicketTypeId(null)
    setIsValidSelection(false)
    setFetchingTickets(false)
    setTicketFiles([])
    !!fetchCancelToken.current && fetchCancelToken.current.cancel("cancel")
  }

  const fetchTickets = async (offset = null) => {
    if (!selectedTicketTypeId) {
      showAxiosError({}, 'No Ticket Type Selected')
      return
    }

    let isShowingModal = false

    setShowModal(showModal => {
      isShowingModal = showModal
      return showModal
    })

    if (!isShowingModal) {
      // This is to cancel fetching if modal is no longer open
      closeModal()
      return
    }

    try {
      setFetchingTickets(true)
      if (!offset) {
        setTicketFiles([])
      }

      const cancelToken = axios.CancelToken.source()
      fetchCancelToken.current = cancelToken
      const response = await bulkPosTicketTypeDownload(event.id, selectedTicketTypeId, 100, offset, cancelToken.token)

      setTicketFiles(prevFiles => [
        ...prevFiles,
        {
          data: response.data.ticketsData,
          name: response.data.ticketsFile,
        },
      ])
      setTotalFiles(response.data.totalBatches)
      if (!response.data.hasNextOffset) {
        setFetchingTickets(false)
      } else {
        fetchTickets(response.data.nextOffset)
      }
    } catch (exception) {
      showAxiosError(exception)
      setFetchingTickets(false)
    }
  }

  function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, {
      type: contentType,
    })

    return blob
  }

  const printTickets = async rawFile => {
    const blob = b64toBlob(rawFile, 'application/pdf')
    const srcUrl = window.URL.createObjectURL(blob)

    if (srcUrl === '') {
      showAxiosError({}, 'No tickets to print')
      return
    }
    let iframe = document.getElementById('tickets-pdf')
    const iframeExists = typeof iframe !== 'undefined' && iframe != null
    if (!iframeExists) {
      iframe = document.createElement('iframe')
      iframe.name = 'tickets-pdf'
      iframe.id = 'tickets-pdf'
      iframe.style.visibility = 'hidden'
    }
    iframe.src = srcUrl
    iframe.onload = () => {
      const pdfFrame = window.frames['tickets-pdf']
      pdfFrame.focus()
      pdfFrame.print()
    }
    if (!iframeExists) {
      document.body.appendChild(iframe)
    }
  }

  function download(rawFile, name) {
    const blob = b64toBlob(rawFile, 'application/pdf')
    const srcUrl = window.URL.createObjectURL(blob)

    if (srcUrl === '') {
      showAxiosError({}, 'No tickets to download')
      return
    }

    downloadAction(srcUrl, name)
  }

  const selectTicketType = event => {
    const value = _get(event, 'value')
    setSelectedTicketTypeId(value ?? null)
    setIsValidSelection(!!value)
    setTicketFiles([])
    setTotalFiles(0)
    setFetchingTickets(false)
    !!fetchCancelToken.current && fetchCancelToken.current.cancel("cancel")
  }

  const downloadAll = async _ => {
    const zip = new JSZip()

    _map(ticketFiles, ticketFile => {
      zip.file(ticketFile.name, b64toBlob(ticketFile.data, 'application/pdf'))
    })

    const data = await zip.generateAsync({ type: 'blob' })
    downloadAction(URL.createObjectURL(data), 'all_tickets.zip')
  }

  const downloadAction = (srcUrl, name) => {
    let a = document.getElementById('download-tickets')
    const aExists = typeof a !== 'undefined' && a != null
    if (!aExists) {
      a = document.createElement('a')
      a.name = 'download-tickets'
      a.id = 'download-tickets'
    }
    a.href = srcUrl
    a.download = name
    if (!aExists) {
      document.body.appendChild(a)
    }
    a.click()
    URL.revokeObjectURL(srcUrl)
  }

  const conditionalOverlay = (element, { text, id, placement = 'left' }, condition = false) => {
    if (condition) {
      return (
        <OverlayTrigger hideTooltip={isValidSelection} placement={placement} id={id} overlay={text}>
          {element}
        </OverlayTrigger>
      )
    }
    return element
  }

  return (
    <>
      <button onClick={() => openModal()} className="btn btn-primary btn-shadow">
        Print Ticket Type Tickets
      </button>
      <Modal
        className="modal-dialog modal-trans"
        style={modalStyle}
        isOpen={showModal}
        contentLabel="Modal"
        onRequestClose={() => closeModal()}
        closeTimeoutMS={150}
        ariaHideApp={false}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div>
              <div className="modal-header">
                <p className="h4 text-compact">Print Ticket Type Tickets</p>
              </div>
              <div className="modal-body" style={{ minHeight: '500px' }}>
                <div className="row">
                  <div className="col-xs-12">
                    <div className="f-dropdown">
                      <div className="f-label">Ticket Type</div>
                      <Select
                        onChange={event => selectTicketType(event)}
                        options={selectOptions}
                        value={selectedTicketTypeId}
                      />
                    </div>
                  </div>
                </div>
                <div className="row-separator" style={{ paddingTop: '20px' }}></div>
                <div className="row">
                  <div className="col-xs-12">
                    <p className="h4 text-compact" style={{ paddingBottom: '20px' }}>
                      Files {!!ticketFiles.length && `${ticketFiles.length}/${totalFiles}`}
                    </p>
                    {!ticketFiles.length && !fetchingTickets && (
                      <div className="alert alert-info" style={{ verticalAlign: 'middle' }}>
                        <p className="text-info">Select a ticket type and press "Fetch Tickets" to start.</p>
                      </div>
                    )}
                    {!!ticketFiles.length && (
                      <>
                        {_map(ticketFiles, ({ data, name }, index) => {
                          return (
                            <div className="row" key={index}>
                              <div className="col-xs-12" style={{ paddingTop: '20px' }}>
                                <div className="col-md-8 col-xs-12">
                                  <p>{name}</p>
                                </div>
                                <div className="col-md-4 col-xs-12">
                                  <button
                                    type="button"
                                    className="btn btn-success btn-shadow"
                                    onClick={_ => printTickets(data)}
                                    style={{ marginRight: '20px' }}
                                  >
                                    Print
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success btn-shadow"
                                    onClick={_ => download(data, name)}
                                  >
                                    Download
                                  </button>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </>
                    )}
                    {ticketFiles.length < totalFiles && totalFiles > 0 && fetchingTickets && (
                      <div className="row">
                        <div className="col-xs-12" style={{ paddingTop: '20px', textAlign: 'center' }}>
                          <div className="col-xs-12">
                            <p>
                              <i className="fa fa-spin fa-spinner"></i> Fetching next batch of tickets...
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="btn-toolbar btn-toolbar-right">
                  {canDownloadAllFiles && (
                    <Button
                      className="btn btn-success btn-shadow"
                      type="button"
                      onClick={() => downloadAll()}
                    >
                      Download All Files
                    </Button>
                  )}
                  {!canDownloadAllFiles &&
                    conditionalOverlay(
                      <Button
                        className="btn btn-success btn-shadow"
                        type="button"
                        disabled={!isValidSelection || fetchingTickets}
                        onClick={() => fetchTickets()}
                      >
                        {!fetchingTickets && 'Fetch Tickets'}
                        {fetchingTickets && (
                          <>
                            <i className="fa fa-spin fa-spinner" /> <span>Fetching Tickets...</span>
                          </>
                        )}
                      </Button>,
                      {
                        id: 'btn-invalid-selection-overlay',
                        placement: 'left',
                        text: (
                          <Tooltip id="btn-invalid-selection-tooltip">
                            Please select a ticket type first
                          </Tooltip>
                        ),
                      },
                      !isValidSelection,
                    )}
                  <Button className="btn btn-cancel btn-shadow" type="button" onClick={() => closeModal()}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default TicketTypeBulkPrint
